import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import { parseUrl, urlToString } from "Shared/url";
import { pushState } from "Shared/history";
export const isInQuery = (ids) => {
    const url = parseUrl(window.location);
    if (!!!url.query)
        return false;
    return ids.every((i) => url.query[i]);
};
const formatIconName = (s) => {
    if (typeof s !== "string")
        return "";
    return s.charAt(0).toLowerCase() + s.slice(1);
};
export const isDisabled = (facet, facetGroup, values) => {
    if (!!!facetGroup || !!!facet)
        return false;
    if (!!values && values.length > 1 && !!facetGroup)
        return ((!!facet
            ? facet.count < 1
            : facetGroup.facetValues.every((f) => f.count < 1)) &&
            facetGroup.facetValues
                .filter((x) => values.indexOf(x.fieldName) > -1)
                .every((x) => x.count < 1));
    return !!facet
        ? facet.count < 1
        : facetGroup.facetValues.every((f) => f.count < 1);
};
const createQuickFilterBase = (block, i) => {
    const values = epiPropertyValue(block.facet).split(";");
    return {
        buttonText: epiPropertyValue(block.buttonText),
        id: values[0],
        values: values.length > 1 ? values : null,
        icon: !!epiPropertyValue(block.icon)
            ? formatIconName(epiPropertyValue(block.icon))
            : "search",
        sortorder: i,
    };
};
const createQuickFilter = (filterBase, facetGroup, facet) => {
    return {
        sortorder: filterBase.sortorder,
        selected: (!!filterBase.values && isInQuery(filterBase.values)) ||
            (!!facet
                ? facet.selected
                : facetGroup.facetValues.every((f) => f.selected)),
        facetGroup: facetGroup,
        facet: facet,
        values: filterBase.values,
        buttonText: filterBase.buttonText,
        icon: filterBase.icon,
        disabled: isDisabled(facet, facetGroup, filterBase.values),
    };
};
export const getQuickFilterBlocks = (quickFilterBlocks) => {
    const quickFilters = epiPropertyValue(quickFilterBlocks);
    if (!!quickFilters && !!quickFilters.items) {
        const items = quickFilters.items.map((block, i) => createQuickFilterBase(block, i));
        return items;
    }
    return [];
};
export const getValidQuickFilters = (products, facetsToShow) => {
    const buttons = products.facets
        .filter((x) => x.facetValues.length >= 0 &&
        facetsToShow.some((f) => f.id == x.displayName))
        .map((facetGroup) => createQuickFilter(facetsToShow.filter((f) => f.id == facetGroup.displayName)[0], facetGroup, null));
    products.facets
        .filter((x) => x.facetValues.length >= 0)
        .forEach((facetGroup) => facetGroup.facetValues
        .filter((y) => y.count >= 0 &&
        facetsToShow.some((f) => f.id.split(";").indexOf(y.text) > -1))
        .forEach((facet) => buttons.push(createQuickFilter(facetsToShow.filter((f) => f.id == facet.text)[0], facetGroup, facet))));
    return buttons.sort((a, b) => (a.sortorder < b.sortorder ? -1 : 0));
};
const handleSpecialCharacters = (str) => {
    str = str.replace(new RegExp("\\)", "g"), "\\)");
    str = str.replace(new RegExp("\\(", "g"), "\\(");
    return str;
};
export const updateUrlParameter = (uri, key, value, multi, removeValue) => {
    const i = uri.indexOf("#");
    const hash = i === -1 ? "" : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
    const separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (value === null || !!removeValue) {
        uri = !!!removeValue
            ? uri.replace(new RegExp(`([?&]?)${key}=[^&]*`, "i"), "")
            : uri.replace(new RegExp(`([?&]?)${key}=${handleSpecialCharacters(encodeURIComponent(removeValue))}`, "i"), "");
        if (uri.slice(-1) === "?") {
            uri = uri.slice(0, -1);
        }
        if (uri.indexOf("?") === -1)
            uri = uri.replace(/&/, "?");
    }
    else if (uri.match(re) && !!!multi) {
        uri = uri.replace(re, `$1${key}=${value}$2`);
    }
    else {
        uri = `${uri + separator + key}=${value}`;
    }
    return uri + hash;
};
export const handleQuickFilterClick = (item, remove) => {
    const url = parseUrl(window.location);
    if (!!!item.facetGroup)
        return;
    if (!!item.values && item.values.length > 1) {
        let multiurl = urlToString(url);
        for (let index = 0; index < item.values.length; index++) {
            const extraFacet = item.values[index];
            multiurl = updateUrlParameter(multiurl, item.facetGroup.fieldName, remove ? null : extraFacet, true, remove ? extraFacet : null);
        }
        pushState(urlToString(multiurl));
    }
    else if (!!!item.facet) {
        let multiurl = urlToString(url);
        for (let index = 0; index < item.facetGroup.facetValues.length; index++) {
            const groupedFacet = item.facetGroup.facetValues[index];
            multiurl = updateUrlParameter(multiurl, groupedFacet.fieldName, remove ? null : groupedFacet.id, true, remove ? groupedFacet.id : null);
        }
        pushState(urlToString(multiurl));
    }
    else {
        const newUrl = updateUrlParameter(urlToString(url), item.facet.fieldName, item.facet.id, item.facetGroup.fieldName == item.facet.fieldName, remove ? item.facet.id : null);
        pushState(urlToString(newUrl));
    }
};
